// removed by extract-text-webpack-plugin
module.exports = {"component":"MedicineTable__component___1DrHJ","table":"MedicineTable__table___3P_KZ","pagination":"MedicineTable__pagination___2J4IH","itemSelected":"MedicineTable__itemSelected___2izwz"};


//////////////////
// WEBPACK FOOTER
// ./src/admin/components/MedicineTable.css
// module id = 374
// module chunks = 0